<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						Coupon Campaign Details
					</div>
					<div class="card-body overflow-auto">
						<div class="col-md-12">
							<div class="card card-primary card-outline">
								{{coupon_campaign}}
							</div>
						</div>
						<br>
						<div class="col-md-12">
							<div class="card card-primary card-outline">
								<div class="card-body">
									<table class="table table-hover table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col">Lower Limit</th>
												<th scope="col">Upper Limit</th>
												<th scope="col">Coupon Value</th>
												<th scope="col">Coupon Validity</th>
												<th scope="col">Redemption Limit Value</th>
												<th scope="col">Status</th>
												<th scope="col">Manage</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="rule in rules">
												<td>{{rule.lower_limit}}</td>
												<td>{{rule.upper_limit}}</td>
												<td>{{rule.coupon_value}}</td>
												<td>{{rule.coupon_validity}}</td>
												<td>{{rule.redemption_limit_value}}</td>
												<td>{{rule.status}}</td>
												<td>
													<button class="btn btn-success" v-if="rule.status==0" @click="changeRuleStatus(rule.id)"><i class="fa fa-play"></i></button>
													<button class="btn btn-danger" v-else-if="rule.status==1" @click="changeRuleStatus(rule.id)"><i class="fa fa-square"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="card-footer">
									<div class="row">
										<div class="col-sm-5">
											<div class="form-group">
												<input type="number" class="form-control" v-model="rule.lower_limit" placeholder="Enter the lower limit">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<input type="number" class="form-control" v-model="rule.upper_limit" placeholder="Enter the upper limit">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<input type="number" class="form-control" v-model="rule.coupon_value" placeholder="Enter the coupon value" min="0">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<input type="date" class="form-control" v-model="rule.coupon_validity" placeholder="Enter the coupon validity">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<input type="number" class="form-control" v-model="rule.redemption_value_limit" placeholder="Enter the redemption limit" min="0">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<button class="btn btn-primary" @click="addRule">Add Rule</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<br>
						<div class="col-md-12">
							<div class="card card-primary card-outline">
								<div class="card-body">
									<table class="table table-hover table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col">Brand</th>
												<th scope="col">Item Code</th>
												<th scope="col">Product</th>
												<th scope="col">Status</th>
												<th scope="col">Manage</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="e in coupon_exceptions">
												<td>{{e.brand}}</td>
												<td>{{e.itemcode}}</td>
												<td>{{e.product}}</td>
												<td>{{e.status}}</td>
												<td>
													<button class="btn btn-success" v-if="e.status==0" @click="changeExceptionStatus(e.id)"><i class="fa fa-play"></i></button>
													<button class="btn btn-danger" v-else-if="e.status==1" @click="changeExceptionStatus(e.id)"><i class="fa fa-square"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="card-footer">
									<div class="row">
										<div class="col-sm-5">
											<div class="form-group">
												<input type="text" class="form-control" v-model="coupon_exception.name" placeholder="Enter the brand/item code/product">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_exception.type" value="brand" id="brand">
												<label class="form-check-label" for="brand">
													Brand
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_exception.type" value="item_code" id="item_code">
												<label class="form-check-label" for="item_code">
													Item Code
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_exception.type" value="product" id="product">
												<label class="form-check-label" for="product">
													Product
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<button class="btn btn-primary" @click="addException">Add Exception</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>


			<br>
			<div class="col-md-12">
							<div class="card card-primary card-outline">
								<div class="card-body">
									<table class="table table-hover table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col">Brand</th>
												<th scope="col">Item Code</th>
												<th scope="col">Product</th>
												<th scope="col">Category</th>
												<th scope="col">Classification</th>
												<th scope="col">Status</th>
												<th scope="col">Manage</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="e in coupon_usage_exceptions">
												<td>{{e.brand}}</td>
												<td>{{e.itemcode}}</td>
												<td>{{e.product}}</td>
												<td>{{e.category}}</td>
												<td>{{e.classification}}</td>
												<td>{{e.status}}</td>
												<td>
													<button class="btn btn-success" v-if="e.status==0" @click="changeUsageExceptionStatus(e.id)"><i class="fa fa-play"></i></button>
													<button class="btn btn-danger" v-else-if="e.status==1" @click="changeUsageExceptionStatus(e.id)"><i class="fa fa-square"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="card-footer">
									<div class="row">
										<div class="col-sm-5">
											<div class="form-group">
												<input type="text" class="form-control" v-model="coupon_usage_exception.name" placeholder="Enter the brand/item code/product">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_usage_exception.type" value="brand" id="brand">
												<label class="form-check-label" for="brand">
													Brand
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_usage_exception.type" value="item_code" id="item_code">
												<label class="form-check-label" for="item_code">
													Item Code
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_usage_exception.type" value="product" id="product">
												<label class="form-check-label" for="product">
													Product
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_usage_exception.type" value="category" id="category">
												<label class="form-check-label" for="category">
													Category
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-check form-check-inline form-group">
												<input type="radio" class="form-check-input" v-model="coupon_usage_exception.type" value="classification" id="classification">
												<label class="form-check-label" for="classification">
													Classification
												</label>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<button class="btn btn-primary" @click="addUsageException">Add Usage Exception</button>
											</div>
										</div>
									</div>
								</div>



				</div>
			</div>
			<br>
			<div class="col-md-12">
							<div class="card card-primary card-outline">
								<div class="card-body">
									<table class="table table-hover table-striped table-bordered">
										<thead>
											<tr>
												<th scope="col">Code</th>
												<th scope="col">Value</th>
												<th scope="col">Redeemed</th>
												<th scope="col">Remaining</th>
												<th scope="col">Status</th>
												<th scope="col">Manage</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="e in coupons">
												<td>{{e.code}}</td>
												<td>{{e.value}}</td>
												<td>{{e.redeemed}}</td>
												<td>{{e.remaining_value}}</td>
												<td>{{e.status}}</td>
												<td>
													<button class="btn btn-success" v-if="e.status==0" @click="changeCouponStatus(e.id)"><i class="fa fa-play"></i></button>
													<button class="btn btn-danger" v-else-if="e.status==1" @click="changeCouponStatus(e.id)"><i class="fa fa-square"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="card-footer">
									<div class="row">
										<div class="col-sm-5">
											<div class="form-group">
												<input type="text" class="form-control" v-model="coupon.code" placeholder="Enter the coupon code">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<input type="number" class="form-control" v-model="coupon.number" placeholder="Enter the no. of coupons to be genereted" min="1">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<input type="number" class="form-control" v-model="coupon.value" placeholder="Enter the coupon value" min="1">
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<button class="btn btn-primary" @click="generateNormalCoupon">Generate Coupon</button>
											</div>
										</div>
										<div class="col-sm-5">
											<div class="form-group">
												<button class="btn btn-primary" @click="generateCustomCoupon">Generate Custom Coupon</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getCoupons(pagination.prevPageUrl)"
						  @next="getCoupons(pagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
        	this.getCouponCampaign();
        	this.getRules();
        	this.getExceptions();
        	this.getUsageExceptions();
        	this.getCoupons();
        },

        data(){
        	return {
        		coupon_campaign: {},
        		rule: new Form({
        			campaign_id: '',
        			lower_limit: '',
        			upper_limit: '',
        			coupon_value: '',
        			coupon_validity: '',
        			redemption_value_limit: ''
        		}),
        		rules: [],
        		coupon_exception: new Form({
        			campaign_id: '',
        			name: '',
        			type: ''
        		}),
        		coupon_exceptions: [],

        		coupon_usage_exception: new Form({
        			campaign_id: '',
        			name: '',
        			type: ''
        		}),
        		coupon_usage_exceptions: [],
        		coupons: [],
        		coupon: new Form({
        			code: '',
        			number: '',
        			value: '',
        			campaign_id: ''
        		}),
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
        	}
        },

        methods: {
        	getCouponCampaign(){
        		axios.post("/api/getCouponCampaign", {id: this.$route.params.id})
        		.then(response => {
        			this.coupon_campaign = response.data;
        		});
        	},

        	addRule(){
        		this.rule.campaign_id = this.$route.params.id;
        		this.rule.post("/api/addCouponRule")
        		.then(() => {
        			toast.fire({
        				title: 'Rule Added',
        				icon: 'success'
        			});
        			this.rule.reset();
        			this.getRules();
        		})
        		.catch(() => {
        			toast.fire({
        				title: 'Input Valid Data in all Fields',
        				icon: 'error'
        			});
        		});
        	},

        	getRules(){
        		axios.post("/api/getCouponRules", {campaign: this.$route.params.id})
        		.then(response => {
        			this.rules = response.data;
        		});
        	},

        	addException(){
        		this.coupon_exception.campaign_id = this.$route.params.id;
        		this.coupon_exception.post("/api/addCouponException")
        		.then(() => {
        			toast.fire({
        				title: 'Exception Added',
        				icon: 'success'
        			});
        			this.coupon_exception.reset();
        			this.getExceptions();
        		})
        		.catch(() => {
        			toast.fire({
        				title: 'Enter Valid Input',
        				icon: 'error'
        			});
        		});
        	},

        	getExceptions(){
        		axios.post("/api/getCouponExceptions", {campaign: this.$route.params.id})
        		.then(response => {
        			this.coupon_exceptions = response.data;
        		});
        	},

        	changeRuleStatus(id){
        		axios.post("/api/changeCouponRuleStatus", {id: id})
        		.then(() => {this.getRules();});
        	},

        	changeExceptionStatus(id){
        		axios.post("/api/changeCouponExceptionStatus", {id: id})
        		.then(() => {this.getExceptions();});
        	},

        	getUsageExceptions(){
        		axios.post("/api/getCouponUsageExceptions", {campaign: this.$route.params.id})
        		.then(response => {
        			this.coupon_usage_exceptions = response.data;
        		});
        	},

        	addUsageException(){
        		this.coupon_usage_exception.campaign_id = this.$route.params.id;
        		this.coupon_usage_exception.post("/api/addCouponUsageException")
        		.then(() => {
        			toast.fire({
        				title: 'Exception Added',
        				icon: 'success'
        			});
        			this.coupon_usage_exception.reset();
        			this.getUsageExceptions();
        		})
        		.catch(() => {
        			toast.fire({
        				title: 'Enter Valid Input',
        				icon: 'error'
        			});
        		});
        	},

        	changeUsageExceptionStatus(id){
        		axios.post("/api/changeCouponUsageExceptionStatus", {id: id})
        		.then(() => {this.getUsageExceptions();});
        	},

        	getCoupons(url="/api/getCampaignCoupons"){
        		axios.post(url, {campaign: this.$route.params.id})
        		.then(response => {
        			this.coupons = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

        	generateNormalCoupon(){
        		this.coupon.campaign_id = this.$route.params.id;
        		this.coupon.post("/api/generateCoupons")
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Generated'
        			});
        			this.getCoupons();
        		})
        		.catch(() => {
        			toast.fire({
        				title: 'Enter valid data',
        				icon: 'success'
        			});
        		});
        	},

        	generateCustomCoupon(){
        		this.coupon.campaign_id = this.$route.params.id;
        		this.coupon.post("/api/generateCustomCoupon")
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Generated'
        			});
        			this.getCoupons();
        		})
        		.catch(() => {
        			toast.fire({
        				title: 'Enter valid data',
        				icon: 'success'
        			});
        		});
        	},

        	changeCouponStatus(id){
        		axios.post("/api/changeCouponStatus", {id: id})
        		.then(() => {
        			this.getCoupons();
        		});
        	}
        }
    }
</script>
